const USER_TYPE_ARCH = 1;
const USER_TYPE_CLIENT = 2;
const PLUS_ACTION = 'PLUS_ACTION';
const MINUS_ACTION = 'MINUS_ACTION';
const STEP_PROJECT_NAME = 'STEP_PROJECT_NAME';
const MATERIAL_NOT_FOUND = 'MATERIAL_NOT_FOUND';
const FINISH_NOT_FOUND = 'FINISH_NOT_FOUND';
const PRIVACY_TERM = '_PRIVACY_NANO';

const MY_PANEL = 'my_panel';
const PROFILE = 'profile';
const NOTIFICATION = 'notifications';
const MY_PLAIN = 'MY_PLAIN';
const COMPETITIONS = 'COMPETITIONS';
const MY_COMPETITIONS= 'my_competition';
const WON_COMPETITIONS = 'won_competitions';
const REGISTER_PARTNER_MATERIAL = 'adm_materials_partner'
const REGISTER_MATERIAL = 'adm_register_materials';
const REGISTER_BUDGET = 'adm_budget_materials';
const REGISTER_PARAMS = 'adm_budget_parameters'
const REGISTER_BUDGET_PARTNER = 'adm_budget_partner'
const CHANGE_LINK_LAYOUT = 'adm_link_layout'
const REGISTER_BUDGET_PARTNER_LIST = 'adm_budget_list_partner'
const PROJECTS = 'projects'
const SUPER_ADM = 'super_adm'
const SUPER_ADM_PARTNER = 'super_adm_partner'
const REGISTER_PARTNER_CREATE = 'adm_partner_create'
const COMPETITION_LIST = 'super_adm_budget_list'

const USER_ROLES = {
    FREE_USER: 1,
    PAYING_USER: 2,
    ADMINISTRATOR_USER: 3,
    ADMINISTRATOR_USER_SUPER: 4,
    ADMINISTRATOR_PARTNER: 5,
    ADMINISTRATOR_PARTNER_SUPER: 6,
}

const PAYMENT_METHODS = {
    BANK_SLIP: 0,
    PIX: 1,
    CREDIT_CARD: 2,
    BANK_TRANSFER: 3,
    MONEY: 5
}

export const PLAN_CODES = {
    FREE_PLAN_CODE: 1,
    MONTH_PLAN_CODE: 2,
    SEMESTER_PLAN_CODE: 3,
    YEARLY_PLAN_CODE: 4
}

const PROJECT_CREATED = 1

const PROJECT_UPDATED = 2 

const FLOW_EMPLOYEE_TYPE = {
    MEASURER: 'MEASURER',
    INSTALLER: 'INSTALLER',
}

export {
    USER_TYPE_ARCH,
    USER_TYPE_CLIENT,
    PLUS_ACTION,
    MINUS_ACTION,
    STEP_PROJECT_NAME,
    MATERIAL_NOT_FOUND,
    FINISH_NOT_FOUND,
    PRIVACY_TERM,
    MY_PANEL,
    PROFILE,
    NOTIFICATION,
    MY_PLAIN,
    COMPETITIONS,
    MY_COMPETITIONS,
    WON_COMPETITIONS,
    PROJECTS,
    SUPER_ADM,
    USER_ROLES,
    REGISTER_MATERIAL,
    REGISTER_BUDGET,
    REGISTER_PARAMS,
    PAYMENT_METHODS,
    PROJECT_CREATED,
    PROJECT_UPDATED,
    REGISTER_BUDGET_PARTNER,
    REGISTER_PARTNER_MATERIAL,
    REGISTER_BUDGET_PARTNER_LIST,
    SUPER_ADM_PARTNER,
    REGISTER_PARTNER_CREATE,
    COMPETITION_LIST,
    CHANGE_LINK_LAYOUT,
    FLOW_EMPLOYEE_TYPE
}